import {useTranslation} from 'react-i18next'
import {CableIcon} from '~/react/icons/CableIcon'

export const stepName = 'connectAccountingProvider'

export const useConnectAccountingProviderStep = () => {
  const {t} = useTranslation('points')
  const i18nPrefix =
    'points:dashboardScreen.onboardingStepper.steps.connectAccountingProvider'
  const onClick = () => {}

  return {
    name: stepName,
    status: 'completed',
    icon: <CableIcon />,
    title: t(`${i18nPrefix}.title`),
    subtitle: {
      default: t(`${i18nPrefix}.subtitle`),
    },
    action: {
      label: t(`${i18nPrefix}.actionLabel`),
      onClick,
    },
  }
}
